<div [ngClass]="{
    page_wrapper: isMinimize == false,
    'minimize-page-wrapper': isMinimize == true
  }">
  <div class="container">
    <div class="">
      <a href="{{ homePageUrl }}" class="link-hover">
        <img src="/assets/images/logo1.svg" class="w-20 mb-2 ml-3 ml-md-0 mt-2" />
      </a>
    </div>
    <div [ngClass]="{ 'joineeVideo position-relative w-100': isMinimize == false }">
      <app-participants #participants (leaveRoom)="onLeaveRoom($event)" [role]="role" [isMinimize]="isMinimize"
        (participantsChanged)="onParticipantsChanged($event)" [style.display]="!!activeRoom ? 'block' : 'none'"
        [activeRoomName]="!!activeRoom ? activeRoom.name : null">
      </app-participants>
      <div class="position-absolute" [ngClass]="{
          ownVideo: isMinimize === false,
          ownVideoMinWindow: isMinimize === true
        }" [class.position-initial]="!activeRoom">
        <div [ngClass]="{ 'audio-bg': activeRoom, 'audio-bgColor': !activeRoom }">
          <app-camera #camera></app-camera>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-primary pl-5 pr-5 btn-rounded" (click)="joinRoom()"
          *ngIf="!activeRoom && !isMinimize">
          JOIN
        </button>
      </div>
      <div class="row position-absolute text-center bottom-15 w-100" [style.display]="!!activeRoom ? 'block' : 'none'">
        <div class=" ">
          <div class="pl-5 pr-5 pt-2">
            <i class="fa font-size-28 pl-3 pr-0 pr-md-3 mr-3 round-video cursor" style="width: 55px; height: 45px"
              [ngClass]="{
                'fa-microphone': !isMute,
                'fa-microphone-slash': isMute
              }" (click)="handleVoice()"></i>
            <i *ngIf="videoCall" class="fa round-video font-size-28 pl-3 pr-3 fa-video-camera cameraHeight cursor"
              style="width: 55px" [ngClass]="{ 'video-off': vedioOff }" (click)="handleVedio()"></i>
            <span *ngIf="videoCall" class="switchCam font-size-28 pl-3 pr-3 cursor" id="video" (click)="switchCamera()">
              <img class="round-video" src="../../../../assets/images/camera-rotate.svg" width="55" />
            </span>
            <!-- <i
              class="material-icons font-size-28 pl-3 pr-3 cursor flip-camera"
              (click)="switchCamera()"
            ></i> -->
            <!-- <span>
              <i class="material-icons" style="font-size: 36px"
                >switch_camera</i
              >
            </span> -->
            <i class="fa fa-phone font-size-28 cursor text-light ml-2 icons rounded-circle pt-2 pl-1 bg-danger"
              (click)="disconnectRoom()"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>